import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { StyledTextField } from 'bento-ordering/base/components/StyledTextField';

function TextInput({
  placeholder,
  defaultValue,
  label,
  onChange,
  value,
  maxLength,
  dataTestId,
  disabled = false
}) {
  return (
    <Box mt={2.5}>
      <StyledTextField
        variant="outlined"
        placeholder={placeholder}
        defaultValue={defaultValue}
        label={label}
        onChange={onChange}
        value={value}
        disabled={disabled}
        inputProps={{ maxLength, 'data-testid': dataTestId }}
      />
    </Box>
  );
}

TextInput.propTypes = {
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  maxLength: PropTypes.string,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool
};

export default TextInput;
